import { normalize } from 'normalizr';
import { map } from 'lodash';
import { receiveEntities } from '../entities';
import { lfpGameSchema } from '../../schemas/lfpGame';

import { getEndpoint, getHeaders } from '../../helpers/endpoint';

export const REQUEST_FETCH_LFP_GAME = 'REQUEST_FETCH_LFP_GAME';
export const SUCCESS_FETCH_LFP_GAME = 'SUCCESS_FETCH_LFP_GAME';
export const FAIL_FETCH_LFP_GAME = 'FAIL_FETCH_LFP_GAME';

export const fetchLfpGame = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_LFP_GAME, payload, scope });

        fetch(getEndpoint('fetchLfpGame', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({
                    type: FAIL_FETCH_LFP_GAME,
                    error: data.error,
                    payload,
                    scope
                });
                else dispatch(successFetchLfpGame(data, payload, scope));
            })
            .catch((error, type = FAIL_FETCH_LFP_GAME) => { dispatch({ type, error, payload, scope }); });
    };
};

function successFetchLfpGame(response, payload, scope) {
    return dispatch => {
        const normalized = normalize(response, lfpGameSchema);

        dispatch(receiveEntities(normalized.entities));
        dispatch({
            type: SUCCESS_FETCH_LFP_GAME,
            receivedAt: Date.now(),
            id: normalized.result,
            payload,
            scope
        });
    };
}

export const REQUEST_FETCH_LFP_GAME_WINNER = 'REQUEST_FETCH_LFP_GAME_WINNER';
export const SUCCESS_FETCH_LFP_GAME_WINNER = 'SUCCESS_FETCH_LFP_GAME_WINNER';
export const FAIL_FETCH_LFP_GAME_WINNER = 'FAIL_FETCH_LFP_GAME_WINNER';

export const fetchLfpGameWinners = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_FETCH_LFP_GAME_WINNER, payload, scope });

        fetch(getEndpoint('fetchLfpGameWinners', payload), {
            method: 'GET',
            headers: getHeaders(getState().authentication)
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({
                    type: FAIL_FETCH_LFP_GAME_WINNER,
                    error: data.error,
                    payload,
                    scope
                });
                else dispatch(successFetchLfpGameWinner(data, payload, scope));
            })
            .catch((error, type = FAIL_FETCH_LFP_GAME_WINNER) => { dispatch({ type, error, payload, scope }); });
    };
};

function successFetchLfpGameWinner(response, payload, scope) {
    return dispatch => {
        dispatch({
            type: SUCCESS_FETCH_LFP_GAME_WINNER,
            success: response,
            receivedAt: Date.now(),
            response,
            payload,
            scope
        });
    };
}

export const REQUEST_CREATE_LFP_GAME = 'REQUEST_CREATE_LFP_GAME';
export const SUCCESS_CREATE_LFP_GAME = 'SUCCESS_CREATE_LFP_GAME';
export const FAIL_CREATE_LFP_GAME = 'FAIL_CREATE_LFP_GAME';

export const createLfpGame = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_CREATE_LFP_GAME, payload, scope });

        return fetch(getEndpoint('createLfpGame'), {
            method: 'POST',
            headers: getHeaders(getState().authentication),
            body: JSON.stringify(payload)
        })
            .then(response => response.json()).then(data => {
                if(data.error) dispatch({
                    type: FAIL_CREATE_LFP_GAME,
                    error: data.error,
                    payload,
                    scope
                });
                else dispatch(successCreateLfpGame(data, payload, scope));
            })
            .catch((error, type = FAIL_CREATE_LFP_GAME) => { dispatch({ type, error, payload, scope }); });
    };
};

function successCreateLfpGame(response, payload, scope) {
    return dispatch => {
        dispatch(receiveEntities({ lfpGames: {[payload.day]: payload} }));
        dispatch({
            type: SUCCESS_CREATE_LFP_GAME,
            success: response.success,
            receivedAt: Date.now(),
            id: payload.day,
            response,
            payload,
            scope
        });
    };
}

export const REQUEST_ADD_LFP_GAME_MATCH = 'REQUEST_ADD_LFP_GAME_MATCH';
export const SUCCESS_ADD_LFP_GAME_MATCH = 'SUCCESS_ADD_LFP_GAME_MATCH';
export const FAIL_ADD_LFP_GAME_MATCH = 'FAIL_ADD_LFP_GAME_MATCH';

export const addLfpGameMatch = (payload, scope) => {
    return (dispatch, getState) => {
        dispatch({ type: REQUEST_ADD_LFP_GAME_MATCH, payload, scope });

        map(payload, (match, key) => {
            match = {
                id: key,
                home: parseInt(match.home, 10),
                away: parseInt(match.away, 10),
                location: match.location,
                date: match.date,
            };

            fetch(getEndpoint('addLfpGameMatch'), {
                method: 'POST',
                headers: getHeaders(getState().authentication),
                body: JSON.stringify(match)
            })
                .then(response => response.json()).then(data => {
                    if(data.error) {
                        dispatch({
                            type: FAIL_ADD_LFP_GAME_MATCH,
                            error: data.error,
                            payload,
                            scope
                        });
                        return false;
                    }
                    else dispatch(successAddLfpGameMatch(data, payload, scope));
                })
                .catch((error, type = FAIL_ADD_LFP_GAME_MATCH) => { dispatch({ type, error, payload, scope }); });
        })
    };
};

function successAddLfpGameMatch(response, payload, scope) {
    return dispatch => {
        dispatch(receiveEntities({ lfpGames: {[payload.day]: payload} }));
        dispatch({
            type: SUCCESS_ADD_LFP_GAME_MATCH,
            success: response.success,
            receivedAt: Date.now(),
            id: payload.day,
            response,
            payload,
            scope
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/entities/lfpGame.js